export default {
    inputAppName: '请输入应用名称',
    noResult: '暂无“{keyword}”相关的搜索结果'
};
